export default __webpack_public_path__ + "files/media/fleet-ar-m.8a902064.jpg";